import { useContext, useState } from "react";
import { IAxiosError } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { InvoicesArchiveGrid } from "./components/InvoicesArchiveGrid";

export function InvoicesArchivePage() {
  const { res } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();

  return (
    <AvisForm title={res("licensees_Invoices_PageTitle_archive")} error={error}>
      <AvisDescriptiveText textKey="portal_LIC_InvoiceArchive" />
      <InvoicesArchiveGrid setError={setError} />
    </AvisForm>
  );
}
